<template>
  <div class="video">
    <div v-if="addUpdate === 1">
      <div class="title">
        视频管理
        <p></p>
      </div>

      <div class="contents">
        <div class="btn_div">
          <!-- <el-button class="all" :class="all === '5' ? 'btnFocus' : ''" @click="statusBtn('5')">全部</el-button>
          <el-button class="all" :class="all === '0' ? 'btnFocus' : ''" @click="statusBtn('0')">已推荐</el-button>
          <el-button class="all" :class="all === '1' ? 'btnFocus' : ''" @click="statusBtn('1')">已审批</el-button>-->
          <el-button class="add" @click="addVideo">新增</el-button>
        </div>

        <!-- data中分页-->
        <el-table
          :header-cell-style="{background: '#f2f2f2',color: '#333333',fontSize: '14px'}"
          :row-style="{height: '50px'}"
          border
		  :data="videosList.slice( (pageIndex - 1) * pageSize, pageIndex * pageSize )"
        >
		 <el-table-column header-align="center" align="center" width="100" label="封面">
			  <template slot-scope="scope">
				<img :src="$getSrc(scope.row.image)" alt class="tabImg" />
			  </template>
		 </el-table-column>
		
          <el-table-column header-align="center" align="center" width="235" label="标题" prop="title"></el-table-column>
          <el-table-column header-align="center"  align="center" width="200" label="上传时间" prop="uploadDate"></el-table-column>
		  <el-table-column header-align="center" align="center" width="103" label="状态" prop="auditStatus"></el-table-column>
          
		  <el-table-column header-align="center" align="center" width="220" label="操作">
            <template slot-scope="scope">
              <el-button type="text" class="caoz" @click="recommend">推荐</el-button>
              <el-button type="text" class="caoz" @click="seeInfo(scope.row.id)">查看</el-button>
              <el-button type="text" class="caoz" @click="update(scope.row.id)" v-if="scope.row.auditStatus === '- 待审核' || scope.row.auditStatus ==='- 未通过'">编辑</el-button>
              <el-button type="text" class="caoz" @click="deleteVE(scope.row.id)" v-if="scope.row.auditStatus === '- 待审核' ||scope.row.auditStatus === '- 未通过'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-dialog title="提示" :visible.sync="tui" width="580px" @beforeClose="tui = false">
        <div class="tuiContent">
          <p>如有案例欲推荐发布至展会首页“案例中心”请联系管理员</p>
          <p>010-82210085</p>
        </div>
        <span slot="footer" class="dialog-footer tuiFooter">
          <el-button type="primary" @click="tui = false">知道了</el-button>
        </span>
      </el-dialog>

      <div class="fenye">
        <el-pagination
          background
          @current-change="currentChangeHandle"
          :current-page="pageIndex"
          :page-size="pageSize"
          :total="videosList.length"
          layout="slot"
        >
          <span style="color: #7a7a7a;font-size: 12px;margin-right: 15px;line-height: 36px;">
            共
            {{ totalIndex }}
            页
          </span>
          <el-button
            :disabled="firstPageBtnDisabled"
            class="first-pager"
            @click="toFirstPage"
          ><< &nbsp;首页</el-button>
        </el-pagination>
        <el-pagination
          background
          @current-change="currentChangeHandle"
          :current-page="pageIndex"
          :page-size="pageSize"
          :total="videosList.length"
          layout="pager, next, slot, jumper "
        >
          <el-button
            :disabled="lastPageBtnDisabled"
            class="first-pager"
            @click="toLastPage"
          >末页 &nbsp;>></el-button>
        </el-pagination>
      </div>
    </div>
	
	
    <add-update-video
      v-if="addUpdate === 0"
      @addUpdateStatus="addUpdateStatus"
      @getVideoList="getVideoList"
      :see="see"
      :videoId="videoId"
    ></add-update-video>
  </div>
</template>
<script>
import addUpdateVideo from "./add-or-update-video";
export default {
  components: {
    addUpdateVideo,
  },
  data() {
    return {
      firstPageBtnDisabled: true,
      lastPageBtnDisabled: false,
      videosList: [],
      pageSize: 5, // 每页条数
      pageIndex: 1, // 当前页
      totalIndex: 0,
      addUpdate: 1,
      all: "5",
      see: true,
      videoId: "",
      tui: false,
    };
  },
  mounted() {
    this.getVideoList();
  },
  methods: {
    // 所有视频
    getVideoList() {
		this.$http({
		  url: "getAccountVideoList",
		  method: "post",
		  params: {
		    id: this.$store.state.userInfo.id,
		  },
		}).then(({ data }) => {
		  let { code, accountVideoList } = data;
			  if (code === 0) {
				accountVideoList.forEach((res) => {
				  if (res.auditStatus === "0") {
				    res.auditStatus = "- 待审核";
				  } else if (res.auditStatus === "2") {
				    res.auditStatus = "- 未通过";
				  }else{
					if(res.display  === "0"){
					  res.auditStatus = "- 已下线";
					}else{
					  res.auditStatus = "- 已发布";
					}
				  }
				});  
				  
				this.videosList = accountVideoList;
				this.totalIndex = Math.ceil(this.videosList.length / this.pageSize);
				
			  } 
		  }).catch(err => {
		    this.$message.error("登录失效，请重新登录");
		    //this.$router.push("/login");
		  })
    },

    // 全部 | 已推荐 | 已审批
    statusBtn(num) {
      this.all = num;
      this.getVideoList();
    },
    // 推荐
    recommend() {
      this.tui = true;
    },
    // 编辑
    update(id) {
      this.addUpdate = 0;
      this.videoId = id;
      this.see = false;
    },
    // 查看
    seeInfo(id) {
      this.addUpdate = 0;
      this.videoId = id;
      this.see = true;
    },
    // 删除
    deleteVE(id) {
      this.$confirm("确认删除当前视频？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http({
          url: "deleteAccountImageVideo",
          method: "post",
          params: {
            id: id,
          },
        })
          .then(({ data }) => {
            if (data.code === 0) {
              this.$message({
                message: `视频删除成功！`,
                type: "success",
                duration: 1000,
                onClose: () => {
                  this.getVideoList();
                },
              });
            }
          })
          .catch((err) => console.log(err));
      });
    },

    addUpdateStatus() {
      this.addUpdate = 1;
    },
    addVideo() {
      this.addUpdate = 0;
      this.see = false;
      this.videoId = "";
    },
	
	//----分页-------开始-----------
   // 每页数
   sizeChangeHandle(val) {
     this.pageSize = val;
     this.pageIndex = 1;
   },
   // 当前页
   currentChangeHandle(val) {
     this.pageIndex = val;
     this.firstPageBtnDisabled = val === 1 ? true : false;
     this.lastPageBtnDisabled = val === this.lastPageNum ? true : false;
   },
   // 首页
   toFirstPage() {
     this.pageIndex = 1;
     this.lastPageBtnDisabled = false;
     this.firstPageBtnDisabled = true;
   },
   // 尾页
   toLastPage() {
     this.pageIndex = this.lastPageNum;
     this.firstPageBtnDisabled = false;
     this.lastPageBtnDisabled = true;
   },
	//----分页-------结束----------
  },
};
</script>
<style lang="scss">
.video {
  .el-table th > .cell {
    padding: 8px;
  }
  
  .tabImg {
    width: 40px;
    height: 40px;
  }
  
  .el-table th,
  .el-table td {
    padding: 5px 0;
  }

  .el-table--border th,
  .el-table--border td {
    border-right: 1px solid #e5e5e5;
  }

  .fenye {
    height: 32px;
    text-align: center;
    margin-top: 57px;
    margin-left: 32%;
    .el-pagination {
      width: 121px;
      float: left;
      .el-pager {
        height: 32px;
        li:not(.disabled).active {
          background-color: #2878ff;
          color: #ffffff;
        }
        .number:hover {
          color: #9ea4b9;
        }
      }
      .btn-next,
      .number {
        width: 32px;
        height: 32px;
        border: 1px solid #e6e6e6;
        border-radius: 5px;
        line-height: 32px;
        color: #9ea4b9;
        background-color: #ffffff;
      }
      .el-pagination__jump {
        height: 32px;
        line-height: 32px;
        margin-left: 15px;
      }
    }
    .first-pager {
      width: 74px;
      height: 32px;
      border: 1px solid #e6e6e6;
      border-radius: 5px;
      text-align: center;
      color: #9ea4b9;
      &:focus,
      &:hover {
        background-color: #ffffff;
      }
    }
  }
  .el-dialog {
    height: 220px;
    margin-top: 33vh;
    border: 1px solid #e5e5e5;
    .el-dialog__header {
      height: 48px;
      padding: 0;
      line-height: 48px;
      text-indent: 31px;
      font-size: 18px;
      .el-dialog__title {
        color: #143372;
      }
      border-bottom: 1px solid #e5e5e5;
    }
    .el-dialog__body {
      height: 102px;
      padding: 0;
      .catalogName {
        width: 520px;
        height: 42px;
        margin: 30px 0 0 29px;
      }
      border-bottom: 1px solid #e5e5ee;
    }
    .el-dialog__footer {
      padding: 0;
      height: 66px;
      background-color: #fafafa;
      .el-button {
        line-height: 0;
      }
      .el-button--default {
        width: 70px;
        height: 34px;
        background-color: #e5e5e5;
        color: #333333;
        text-align: center;
        margin-top: 15px;
        &:hover {
          border-color: #e5e5e5;
        }
      }
      .el-button--primary {
        width: 96px;
        height: 34px;
        color: #ffffff;
        background-color: #143372;
        border-color: #143372;
        margin: 15px 30px 0 12px;
      }
    }
    .tuiContent {
      text-align: center;
      line-height: 30px;
      padding-top: 20px;
    }
    .tuiFooter {
      margin-right: 35%;
    }
  }
}
.el-pagination.is-background .el-pager li {
  border-radius: 5px;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #2878ff;
}
</style>
<style lang="scss" scoped>
.video {
  .title {
    width: 100%;
    height: 66px;
    line-height: 66px;
    font-size: 18px;
    color: #143372;
    position: relative;
    border-bottom: 1px solid #e5e5e5;
    text-indent: 30px;
    margin-bottom: 10px;
    p {
      width: 70px;
      height: 2px;
      background-color: #143372;
      position: absolute;
      bottom: -1px;
      left: 30px;
    }
  }
  .contents {
    width: 860px;
    height: 410px;
    margin-left: 30px;
    .btn_div {
      height: 36px;
      margin: 17px 0;
      .all {
        width: 84px;
        height: 36px;
        border: 1px solid #e5e5e5;
        color: #484848;
        margin-bottom: 18px;
        line-height: 0;
        &:focus {
          border: 1px solid #143372;
          color: #143372;
          background-color: #ffffff;
        }
        &:hover {
          background-color: #ffffff;
        }
      }
      .add {
        height: 36px;
        float: right;
        color: #ffffff;
        background-color: #143372;
        line-height: 0;
      }
    }
  }
  .caoz {
    font-size: 12px;
    color: #17a3dd;
  }
  .btnFocus {
    border: 1px solid #143372 !important;
    color: #143372 !important;
    background-color: #ffffff;
  }
}
</style>